import { render } from "./SearchIcon.vue?vue&type=template&id=e5369e7a&scoped=true"
import script from "./SearchIcon.vue?vue&type=script&lang=js"
export * from "./SearchIcon.vue?vue&type=script&lang=js"

import "./SearchIcon.vue?vue&type=style&index=0&id=e5369e7a&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-e5369e7a"

export default script